import {MdReportProblem} from 'react-icons/md';

type Props = {
  opened: boolean;
  close: () => void;
  openReportModal: () => void;
};

export const TopicItemMoreMenu: React.FC<Props> = ({
  opened,
  close,
  openReportModal,
}) => {
  const onClick = () => {
    openReportModal();
    close();
  };

  return (
    opened && (
      <>
        <div
          className="h-svh w-svw fixed top-0 left-0 bg-transparent z-50"
          onClick={close}
        />
        <div className="bg-white p-4 shadow-modal w-[190px] rounded-4 absolute bottom-[-46px] left-[-4px] z-50">
          <button
            className="flex items-center text-base text-notification-1 leading px-12 w-full h-[38px] hover:opacity-8 "
            onClick={onClick}
          >
            <div className="mr-8">
              <MdReportProblem size={16} />
            </div>
            通報する
          </button>
        </div>
      </>
    )
  );
};
